import { createAuctionSessionQueryOptionsFactory } from "@/queries/auction-session.ts";
import { createAuctionQueryOptionsFactory } from "@/queries/auction.ts";
import { createRegistrationQueryOptionsFactory } from "@/queries/registration.ts";
import { createReviewRequestQueryOptionsFactory } from "@/queries/review-request.js";
import { createReviewQueryOptionsFactory } from "@/queries/review.js";
import { type ReactNode, createContext, useContext } from "react";

export const createQueryOptionsFactory = (authFetch: typeof fetch) => ({
    auction: createAuctionQueryOptionsFactory(authFetch),
    auctionSession: createAuctionSessionQueryOptionsFactory(authFetch),
    registration: createRegistrationQueryOptionsFactory(authFetch),
    review: createReviewQueryOptionsFactory(authFetch),
    reviewRequest: createReviewRequestQueryOptionsFactory(authFetch),
});

export type QueryOptionsFactory = ReturnType<typeof createQueryOptionsFactory>;

const QueryOptionsFactoryContext = createContext<QueryOptionsFactory | null>(null);

type QueryOptionsFactoryProviderProps = {
    children: ReactNode;
    factory: QueryOptionsFactory;
};

export const QueryOptionsFactoryProvider = ({
    children,
    factory,
}: QueryOptionsFactoryProviderProps): ReactNode => (
    <QueryOptionsFactoryContext.Provider value={factory}>
        {children}
    </QueryOptionsFactoryContext.Provider>
);

export const useQueryOptionsFactory = (): QueryOptionsFactory => {
    const factory = useContext(QueryOptionsFactoryContext);

    if (!factory) {
        throw new Error("useQueryOptionsFactory used outside QueryOptionsFactoryProvider");
    }

    return factory;
};
